/**
 * The typed front door.
 *
 * `t("gate.unlock")` compiles; `t("gate.unlok")` does not. `t("name.field")`
 * without `{ id }` does not either: the parameter object is inferred from the
 * `{placeholders}` inside the Ukrainian message literal, so the compiler knows
 * the names before any dictionary is loaded.
 *
 * It is a plain function rather than a hook so the modules that are not
 * components can use it: `lib/api.ts` translates an error code into
 * `ApiError.message`, which is what kept all thirteen sites that display that
 * message untouched. Components use `useT()` from `./index`, which is this
 * function plus a re-render when the locale changes.
 */

import type { MessageKey, Messages } from "./messages/schema";
import { type ArgsFor, translate } from "./runtime";

export function t<K extends MessageKey>(key: K, ...args: ArgsFor<Messages[K]>): string {
  return translate(key, args[0] as Record<string, string | number> | undefined);
}

export type { MessageKey, Messages };
